import React, { useEffect, useState } from 'react';
import "./EditWebCheckIn.css";
import { useNavigate,useLocation } from "react-router-dom";
import axios from 'axios';
import useAuth from '../../../customHooks/useAuth.js';

import { countryCodeList } from '../../../data';
import ImageLoader from "../../../assets/ImageLoader/ImageLoader.jsx";

import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';

import eye from "../../../assets/icons/eye.svg";
import deleteIcon from "../../../assets/icons/delete.svg";
import prevIcon from "../../../assets/icons/coloredPrev.svg";
import PageLoader from '../../../assets/pageLoader/PageLoader.js';
import { baseUrl } from '../../../common/baseUrl';

import aadharImg from "../../../assets/aadharID_front.jpeg"
import axiosInstance from '../../../axiosInstance/axiosInstance';
import Dropdown from "../../components/Dropdown/Dropdown";

export default function EditWebCheckIn() {

  const navigate = useNavigate();
  const location = useLocation(); 

  // Tags
  const tags = location.state?.tags || {};

  // Expected arrival time (preserved across guest edits)
  const timeArrival = location.state?.timeArrival || "";

  // Room Details
  const bookedRooms = location.state?.bookedRooms || [];
  const bookedRoomId = location.state?.bookedRoomId || "";

  // User Id
  const userId = localStorage.getItem("user_id");

  // Hotel View
  const hotelId = location.state?.hotelId || "";
  const bookingId = location.state?.bookingId || "";
  const hotelName = location.state?.hotelName || "";
  const hotelAddress = location.state?.hotelAddress || "";
  const status = location.state?.status || "";
  const activeTab = location.state?.activeTab || "";

  // For Data Updation
  const update= location.state?.update || "";
  const index = location.state?.index !== undefined ? location.state.index : null;
  //  Guest Details for each room 
  const rno = location.state?.rno !== undefined ? location.state.rno : null;
  const guests = location.state?.guests || [];
 
  // CheckIn Date and CheckOut Date
  const checkInDate = location.state?.checkInDate || "";
  const checkOutDate = location.state?.checkOutDate || "";

  // In this if update is there then we will get the data
  const name = location.state?.name || "";
  const verification_id = location.state?.verification_id || "";
  const phone = location.state?.contact || "";
  const phoneString = String(phone).slice(2); // Convert to string and skip the first 2 characters
  const email = location.state?.email || "";
  const address = location.state?.address || "";

  // Minor (under-18) guests only need a name; identity fields are optional.
  const [isMinor, setIsMinor] = useState(location.state?.is_minor || false);

  // Allowed file types
  const allowedImageTypes = ["image/jpeg", "image/png","image/webp" ];


  // Refresh Handle
  useAuth();
 
 
  const [isuser,setIsUser] = useState(false);
  const [imageurl,setImageUrl] = useState("");
  const [showImageModal, setShowImageModal] = useState(false); // State to show/hide the modal
  const [minatureLoad,setMinatureLoad] = useState(false);
  const [userHasImg,setUserHasImg] = useState(false);


  const [urlId1,setUrlId1] = useState("");
  const [urlId2,setUrlId2] = useState("");

  const [imageModal1,setImageModal1] = useState(false);
  const [imageModal2,setImageModal2] = useState(false);

  const [miniImgLoad1,setMiniImgLoad1] = useState(false);
  const [miniImgLoad2,setMiniImgLoad2] = useState(false);


  // Loading
  const [loading, setLoading] = useState(false); // Loading state
 
  // State for managing errors
  const [errors, setErrors] = useState({
    name: "",
    phone: "",
    id: "",
    id1: "",
    id2: "",
  });

  // Button Disabled 
  const [buttonDisabled, setButtonDisabled] = useState(false);

  

  // Combined state for managing form inputs
  const [formData, setFormData] = useState({
    name: name || "",
    email: email || "",
    address : address ||"",
    phone: phoneString || "",
    fileName: verification_id || "",
    countrycode: "+91",
    file: null,
    imageKey: null, // New state to store the image key

    filePreview : "",
    veri_id1 : "",
    veri_id2 : "",
    
    file1 : null,
    filePreviewId1 : "",
    imageKeyId1 : "",

    file2 : null,
    filePreviewId2 : "",
    imageKeyId2 : "",

    verification_id : verification_id || ""
  });


  // Divide the ID's with comma for multiple ID's
  useEffect(()=>{
    const checkWithId = ()=>{
      try{
        if(verification_id.includes(",")){

          const ids = verification_id.split(",");
          setFormData((prev)=>({
            ...prev,
            fileName : ids[0] || "",
            veri_id1 : ids[0] || "",
            veri_id2 : ids[1] || ""
          }))

        }
        else{
          setFormData((prev)=>({
            ...prev,
            fileName : verification_id || "",
            veri_id1 : verification_id || "",
            veri_id2 : ""
          }))
        }
      }catch(error){
        console.log(error);
      }
    }
    checkWithId();
  },[])
  

  const selectedCountry = countryCodeList.find(country => country.code === formData.countrycode);
  const maxLength = selectedCountry ? selectedCountry.length : 10;

  // Country Change
  const handleCountryChange = (e) => {
    const newCode = e.target.value;
    setFormData(prevData => ({
      ...prevData,
      countrycode: newCode,
      phone: "" // Reset phone when country code changes
    }));
  };



  // Input Change
  const handleInputChange = (e, field) => {
    const { value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [field]: value
    }));
    validateField(field, value);
  };
 
  // File Handling
  const handleFileChange = async(e) => {
    try{
      const file = e.target.files[0];
      if (file) {
        const fileURL = URL.createObjectURL(file);
        setFormData((prev) => ({
          ...prev,
          fileName: file.name,
          filePreview: fileURL,
          file: file,
          imageKey: null // Reset image key when a new file is selected
        }));
        try{
          if (allowedImageTypes.includes(file.type)){
            let imageKeyData = await uploadImage(file);
            setFormData(prevData => ({
            ...prevData,imageKey:imageKeyData}));

          }

        }catch(error){
          console.log(error);
        }
  
        validateField("id",file.type);
      }

    }catch(error){
      console.log(error)
    }
  };


  const handleFileChangeId1 = async(e)=>{
      try{
          setMiniImgLoad1(true);
          const file = e.target.files[0];
          if (file) {
            const fileURL = URL.createObjectURL(file);
            setFormData((prev) => ({
                ...prev,
                file1 : file,
                veri_id1 : "",
                filePreviewId1: fileURL,
                imageKeyId1: "" // Reset image key when a new file is selected
            }));

            if (allowedImageTypes.includes(file.type)){
              let imageKeyData = await uploadImage(file);
              console.log("Image Key : " + imageKeyData);
              setFormData(prevData => ({
              ...prevData,imageKeyId1:imageKeyData,
              veri_id1 : imageKeyData}));
            }

            validateField("id1",file.type);
          }
      }catch(error){
        console.log(error)
      }
      finally{
        setMiniImgLoad1(false);
      }
  }


  const handleFileChangeId2 = async(e)=>{
      try{
        setMiniImgLoad2(true);
        const file = e.target.files[0];
        if (file) {

          const fileURL = URL.createObjectURL(file);
          setFormData((prev) => ({
            ...prev,
            veri_id2 : "",
            file2 : file,
            filePreviewId2: fileURL,
            imageKeyId2: "" // Reset image key when a new file is selected
          }));

          if (allowedImageTypes.includes(file.type)){
            let imageKeyData = await uploadImage(file);
            console.log("Image Key : " + imageKeyData);
            setFormData(prevData => ({
            ...prevData,imageKeyId2:imageKeyData,
            veri_id2 : imageKeyData}));
          }
          validateField("id2",file.type);
        }
      }catch(error){
        console.log(error)
      }
      finally{
        setMiniImgLoad2(false);
      }
  }



  // For Handle Change 
  const validateField = (field, value) => {
    const newErrors = { ...errors };
  
    switch (field) {
      case "name":
        if (value.trim() === "") {
          newErrors.name = "Name is required";
        } 
        else if (/\d/.test(value)) {
          newErrors.name = "Name cannot contain digits";
        } else {
          newErrors.name = "";
        }
      break;
        
      case "email":
        if (value.trim() === "") {
          newErrors.email = "Email is required";
        } else if (
          !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)
        ) {
          newErrors.email = "Invalid email address";
        } else {
          newErrors.email = "";
        }
      break;

      case "phone":
        if (value.trim() === "") {
          newErrors.phone = "Phone number is required";
        } else if (value.length !== maxLength) {
          newErrors.phone = `Phone number must be ${maxLength} digits`;
        } else if (!/^\d+$/.test(value)) {
          newErrors.phone = "Phone number must contain only digits";
        } else {
          newErrors.phone = "";
        }
      break;

      case "id1":
        if(value.trim()===""){
          newErrors.id1 = "Front Id is Required";
        }
        else if(!allowedImageTypes.includes(value)){
          newErrors.id1 = "Only images of Extension .jpg, .jpeg, .png, .webp are allowed";
        }
        else{
          newErrors.id1 = ""
        }
        break;

      case "id2":
        if(value.trim()===""){
          newErrors.id2 = "Back Id is Required";
        }
        else if(!allowedImageTypes.includes(value)){
          newErrors.id2 = "Only images of Extension .jpg, .jpeg, .png, .webp are allowed";
        }
        else{
          newErrors.id2 = ""
        }
        break;

      case "address":
        if (value.trim() === "") {
          newErrors.address = "Address is required";
        } 
        else {
          newErrors.address = "";
        }
        break;



      default:
        break;
    }
  
    setErrors(newErrors);
  };
  

  // A contact identifies one guest per booking, so the same number cannot be used by
  // another traveller — in this room or in any other room of the booking. The guest
  // currently being edited is skipped so re-saving them is not flagged as a clash.
  const isContactUsedByAnotherGuest = (contact) => {
    return guests.some((roomGuests, roomIndex) =>
      (roomGuests || []).some((guest, guestIndex) => {
        const isGuestBeingEdited =
          update === "updateBooking" &&
          index !== null &&
          roomIndex === rno &&
          guestIndex === index;

        if (isGuestBeingEdited) {
          return false;
        }

        return guest?.contact != null && Number(guest.contact) === contact;
      })
    );
  };

  // For Final Submission
  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }

    else if (/\d/.test(formData.name)) {
      newErrors.name = "Name cannot contain digits";
    }

    // Minors only require a name — skip contact/email/address/ID checks.
    if (isMinor) {
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (formData.phone.length !== maxLength) {
      newErrors.phone = `Phone number must be ${maxLength} digits`;
    } else if (
      isContactUsedByAnotherGuest(
        parseInt(formData.countrycode.concat(formData.phone), 10)
      )
    ) {
      newErrors.phone = "This number is already added to another guest in this booking";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)
    ) {
      newErrors.email = "Invalid email address";
    }

    if (!formData.address.trim()) {
      newErrors.address = "Address is required";
    } 


    if(!formData.veri_id1){
      newErrors.id1 = "Front ID is required";
    }
    if(!formData.veri_id2){
      newErrors.id2 = "Back ID is required";
    }

    if(formData.file1){
      if (!allowedImageTypes.includes(formData.file1.type)) {
      newErrors.id1 = "Only images of Extension .jpg, .jpeg, .png, .webp are allowed";
      }
    }   
    if(formData.file2){
      if (!allowedImageTypes.includes(formData.file2.type)) {
      newErrors.id1 = "Only images of Extension .jpg, .jpeg, .png, .webp are allowed";
      }
    }   
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  
 
  // Upload Of Image
  // Create a new Axios instance for uploads (without Authorization header)
  const uploadAxios = axios.create(); // This instance should not have any headers by default
  const uploadImage = async (file) => {
    try {
      setButtonDisabled(true);
      // Get the pre-signed URL for upload
      const response = await axiosInstance.get(
        `/api/v1/images/upload-presigned-url?file_name=${file.name}`
      );
      
      const { key, url } = response.data; // Extract key and URL from the response
  
  
      // Ensure no Authorization header is being sent
      uploadAxios.defaults.headers.common['Authorization'] = undefined; // Clear any Authorization headers
  
      // Use the uploadAxios instance to upload the file
      await uploadAxios.put(url, file, {
        headers: {
          "Content-Type": file.type, // Set the appropriate content type
           token : localStorage.getItem("token") || ""
        },
      });
  
      return key;  // Return the uploaded image key
    } catch (error) {
      // Log the error response if available
      console.error("Error uploading image:", error.response ? error.response.data : error.message);
      throw error; // Rethrow the error for handling in the calling function
    }
    finally{
      setButtonDisabled(false);
    }
  };
 

  // Toggle image modal
  const toggleImageModal = () => {
    setShowImageModal(!showImageModal);
  };


  // Trigger API call when the user enter contact 
  useEffect(() => {
    const phoneCheck = async () => {
      if (formData.phone.length === maxLength) {
        try {
          const countryCode = formData.countrycode;
          const phoneString = countryCode.concat(formData.phone);
          const fullPhone = parseInt(phoneString, 10);
          const response = await axiosInstance.get(
            `/api/v1/users?contact=${fullPhone}`
          );
  
  
          if (response.data && response.data.data && response.data.data.length > 0) {
            // Update only if valid
            setIsUser(true);
            setFormData((prevFormData) => ({
              ...prevFormData,
              name: response.data.data[0]?.name || "",
              email: response.data.data[0]?.email || "",
              address: response.data.data[0]?.address || "",
            }));


            // Image
            let verifi_id = response?.data?.data[0]?.verification_id || "";

            if(formData.name!==""){
                setFormData((prev)=>({
                  ...prev,
                  name : formData.name,
                }))
            }
            if(formData.email!==""){
                setFormData((prev)=>({
                  ...prev,
                  email : formData.email,
                }))
            }
            if(formData.address!==""){
                setFormData((prev)=>({
                  ...prev,
                  address : formData.address,
                }))
            }

            if(formData.verification_id!==""){
              if(formData.verification_id.includes(",")){
                const ids = formData.verification_id.split(",");
                setFormData((prev)=>({
                  ...prev,
                  fileName : ids[0] || "",
                  veri_id1 : ids[0] || "",
                  veri_id2 : ids[1] || ""
                }))
              }
              return
            }
            else{
              setUserHasImg(false);
            }

          }else{
            setIsUser(false);
          }  
          
  
        } catch (error) {
          console.log(error);
        }
      }
      else{
        setUserHasImg(false);
        setFormData((prevFormData) => ({
          ...prevFormData,
          fileName: "",
          veri_id2 : "",
          veri_id1 : "",
        }));
        setImageUrl("");
        setUrlId1("");
        setUrlId2("");
      }
    };
      phoneCheck();
  }, [formData.phone, setFormData,formData.countrycode,maxLength]);


  // For Miniature Image
  useEffect(()=>{

    const getImageData = async()=>{
      if(verification_id!==""){
        try{
          setMinatureLoad(true);
          
          const response = await axiosInstance.get(`/api/v1/images/download-presigned-url?key=${verification_id}`);
          const url = response.data.url;
          setImageUrl(url);

        }catch(error){
          console.log(error);
        }
        finally{
          setMinatureLoad(false)
        }
      }
    }
    getImageData();

  },[verification_id]);


  // If It is User of App then Upload Image
  useEffect(()=>{
    if(isuser){

      const getImageData = async()=>{
        if(formData.fileName!==""){
          try{
            setMinatureLoad(true);
            
            const response = await axiosInstance.get(`/api/v1/images/download-presigned-url?key=${formData.fileName}`);
            const url = response.data.url;
            setImageUrl(url);
  
          }catch(error){
            console.log(error);
          }
          finally{
            setMinatureLoad(false)
          }
        }
      }
      getImageData();

    }
  },[isuser,formData.fileName])
 


  // Move Back
  const navigateBack = () => {
    navigate("/webCheckIn", {
      state: {
        bookedRoomId: bookedRoomId,
        guests: guests, // Pass the modified copy
        bookedRooms: bookedRooms,
        // Hotel View
        bookingId: bookingId,
        hotelId: hotelId,
        checkInDate : checkInDate,
        checkOutDate : checkOutDate,
        hotelName : hotelName,
        hotelAddress : hotelAddress,
        activeTab : activeTab,
        status : status,
        selectedTags : tags,
        timeArrival : timeArrival
      },
    });
  };


  const handleSave = async()=>{
    try{
      if(validateForm()){

      setLoading(true);

      // Proceed with saving if no errors

      try{
        let imageKey = formData.imageKey;

        // If there's a new file to upload
        if (formData.file && !imageKey && !isMinor) {
          imageKey = await uploadImage(formData.file);
        }

        const name = formData.name;
        const countryCode = formData.countrycode;
        const contact = countryCode.concat(formData.phone);
        const phone = parseInt(contact, 10);

        // A minor carries only a name; identity fields stay empty and contact is null.
        const buildGuest = () => (
          isMinor
            ? {
                name: name,
                is_minor: true,
                contact: null,
                verification_id: "",
                email: "",
                address: "",
              }
            : {
                name: name,
                is_minor: false,
                contact: phone,
                verification_id: formData.veri_id1 + ',' + formData.veri_id2,
                email: formData.email,
                address: formData.address,
              }
        );

        if (update === "updateBooking" && index !== null) {
          let newGuest = buildGuest();
          guests[rno][index] = newGuest;


          navigate("/webCheckIn", {
            state: {
              bookingId: bookingId,
              hotelId: hotelId,
              bookedRoomId: bookedRoomId,
              guests: guests, // Pass the modified copy
              bookedRooms: bookedRooms,
              userId : userId,
              checkInDate : checkInDate,
              checkOutDate : checkOutDate,
              hotelName : hotelName,
              hotelAddress : hotelAddress,
              activeTab : activeTab,
              status : status,
              selectedTags : tags,
              timeArrival : timeArrival
            },
          });
        
        }
        // Adding the Data
        else {
          let newGuest = buildGuest();

          guests[rno].push(newGuest);
       
         
    
          // After adding the guest, navigate to the webCheckIn page
          navigate("/webCheckIn", {
            state: {
              bookingId: bookingId,
              hotelId: hotelId,
              bookedRoomId: bookedRoomId,
              guests: guests, // Pass the modified copy
              bookedRooms: bookedRooms,
              userId : userId,
              checkInDate : checkInDate,
              checkOutDate : checkOutDate,
              hotelName : hotelName,
              hotelAddress : hotelAddress,
              activeTab : activeTab,
              status : status,
              selectedTags : tags,
              timeArrival : timeArrival
            },
          });
        }

      }catch(error){
        console.log(error);
      }
      }
    }catch(error){
      console.log(error);
    }
  }


  // Toggle ID Modals
  const toggleImageModelId1 = ()=>{
    try{
        setImageModal1(!imageModal1);
    }catch(error){
        console.log(error);
    }
  }

  const toggleImageModelId2 = ()=>{
      try{
          setImageModal2(!imageModal2);
      }catch(error){
          console.log(error);
      }
  }

  // Handle Delete Ids
  const handleDeleteId1 = ()=>{
      try{
          setFormData((prev) => ({
              ...prev,
              veri_id1: "",
          }));
          setUrlId1("");

      }catch(error){
          console.log(error);
      }
  }

  const handleDeleteId2 = ()=>{
      try{
          setFormData((prev) => ({
              ...prev,
              veri_id2: "",
          }));
          setUrlId2("");

      }catch(error){
          console.log(error);
      }
  }


  // Get URL for ID 1
  useEffect(()=>{
      const getImageData1 = async()=>{
        if(formData.veri_id1!==""){
          try{
            setMiniImgLoad1(true);
            const response = await axiosInstance.get(`/api/v1/images/download-presigned-url?key=${formData.veri_id1}`);
            const url = response.data.url;
            setUrlId1(url);
          }catch(error){
            console.log(error);
          }
          finally{
            setMiniImgLoad1(false);
          }
        }
      }
      getImageData1();
  },[formData.veri_id1])


  // Get URL for ID 2
  useEffect(()=>{
    const getImageData2 = async()=>{
      if(formData.veri_id2!==""){
        try{
          setMiniImgLoad2(true);
          const response = await axiosInstance.get(`/api/v1/images/download-presigned-url?key=${formData.veri_id2}`);
          const url = response.data.url;
          setUrlId2(url);
        }catch(error){
          console.log(error);
        }
        finally{
          setMiniImgLoad2(false);
        }
      }
    }
    getImageData2();
  },[formData.veri_id2])

  


  return (
    <>
    {loading && (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999 // Make sure the loader is on top
      }}>
        <PageLoader/>
      </div>
    )}
    <div className="edit-web-checkIn">

      {/* Header */}
      <div className="edit-web-header">
        <div className="edit-web-checkIn-content">
          <div className="prevIcon">
            <img src={prevIcon} alt="" onClick={navigateBack}  />
          </div>
          <div className='edit-web-checkIn-data'>
            <h6>Edit Details</h6>
          </div>
        </div>
      </div>

      {/* Form */}
      <div className="form-traveller">

        {/* Under-18 toggle */}
        <label className={`minor-toggle ${isMinor ? "active" : ""}`}>
          <input
            type="checkbox"
            checked={isMinor}
            onChange={(e) => setIsMinor(e.target.checked)}
          />
          <span className="minor-toggle-box" aria-hidden="true"></span>
          <span className="minor-toggle-text">
            <span className="minor-toggle-title">Guest is under 18 (child)</span>
            <span className="minor-toggle-sub">Only a name is needed — a child checks in with an accompanying adult.</span>
          </span>
        </label>

        {/* Name (always required) */}
        <div className="form-data-user">
          <div className="form-label-data">
            <h4>{isMinor ? "Child's name" : "Your name and title"}</h4>
          </div>
          <div className='form-inputs-user'>
            <input
              type="text"
              value={formData.name}
              onChange={(e) => handleInputChange(e, "name")}
              placeholder="Name"
            />
          </div>
          {errors.name && <p className="error-message">{errors.name}</p>}
        </div>

        {!isMinor && (
        <>

        {/* Phone */}
        <div className="form-data-email">
          <div className="form-label-email">
            <h4>Phone Number</h4>
          </div>
          <div className="form-input-email">

           <div className="form-input-countryCode">
              <Dropdown
                name="countrycode"
                value={formData.countrycode}
                onChange={handleCountryChange}
                placeholder="Country"
                searchPlaceholder="Search country"
                options={countryCodeList.map(country => ({
                  value: country.code,
                  label: `${country.name} (${country.code})`,
                }))}
              />
            </div>
            <div className="form-input-phone">
              <input
                type="text"
                value={formData.phone}
                onChange={(e) => handleInputChange(e, "phone")}
                placeholder="Enter Your Number" maxLength = {maxLength}
              />
            </div>
            
          </div>
          {errors.phone && <p className="error-message">{errors.phone}</p>}
        </div>

        {/* Email */}
        <div className="form-data-email">
          <div className="form-label-email">
            <h4>Email</h4>
          </div>
          <div className="form-input-email">
            <input
              type="text"
              value={formData.email}
              onChange={(e) => handleInputChange(e, "email")}
              placeholder="Email" 
            />
          </div>
          {errors.email && <p className="error-message">{errors.email}</p>}
        </div>

        {/* Address */}
        <div className='form-data-email'>
          <div className='form-label-email'>
            <h4>
              Address
            </h4>
          </div>
          <div className='form-input-address'>
            <textarea name="address" value={formData?.address} placeholder='Address'  
            onChange={(e) => handleInputChange(e, "address")}
            rows="4" cols="10" ></textarea>
          </div>
          {errors.address && <p className="error-message">{errors.address}</p>}
        </div> 

        {/* New Upload I'ds */}
        {
          <div className='webphoto-field'>
            
            <div className='webphoto-field-title'>
              <h4>Uploaded ID</h4>
            </div>
            {errors.id1 && <p className="error-message">{errors.id1}</p>}
            {errors.id2 && <p className="error-message">{errors.id2}</p>}

            <div className='web-ids-data'>

              {
                miniImgLoad1 ? (
                  <>
                    <div className='editProfile-view2'>
                      <div className='user-image-upload-skeleton2'></div>
                    </div>
                  </>

                ) :
                formData.veri_id1 === "" ? (
                  <>
                    <input
                      type="file"
                      style={{ display: 'none' }}
                      accept="image/*"
                      id="fileInput1"
                      onChange={(e)=>handleFileChangeId1(e)}
                    />
                    <label htmlFor="fileInput1" className="web-id-full">
                      <div className="web-id-front">
                        <h2>+</h2>
                      </div>
                      <div className="web-id-front-text">
                        <h4>Front</h4>
                      </div>
                    </label>
                  </>
                ) :(
                  <div className="web-id-full">
                    <div
                      className="web-id-front-bgimg"
                      style={{
                        backgroundImage : `url(${urlId1})`,
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                      }}
                    >
                      <div className="web-id-front-view-remove">
                        <img src={eye} alt="View"  onClick={()=>toggleImageModelId1()}/>
                        <img src={deleteIcon} alt="Delete"  onClick = {()=>handleDeleteId1()} />
                      </div>
                    </div>
                    <div className="web-id-front-text">
                      <h4>Front</h4>
                    </div>
                  </div>
                )
              }


              {
                miniImgLoad2 ? (
                  <>
                    <div className='editProfile-view2'>
                      <div className='user-image-upload-skeleton2'></div>
                    </div>
                  </>

                ) :
                formData.veri_id2 === "" ? (
                  <>
                    <input
                      type="file"
                      style={{ display: 'none' }}
                      accept="image/*"
                      id="fileInput2"
                      onChange={(e)=>handleFileChangeId2(e)}
                      
                    />
                    <label htmlFor="fileInput2" className="web-id-full">
                      <div className="web-id-front">
                        <h2>+</h2>
                      </div>
                      <div className="web-id-front-text">
                        <h4>Back</h4>
                      </div>
                    </label>
                  </>
                ) : (
                  <div className="web-id-full">
                    <div
                      className="web-id-front-bgimg"
                      style={{
                        backgroundImage : `url(${urlId2})`,
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                      }}
                    >
                      <div className="web-id-front-view-remove">
                        <img src={eye} alt="View"  onClick={()=>toggleImageModelId2()}/>
                        <img src={deleteIcon} alt="Delete"  onClick = {()=>handleDeleteId2()} />
                      </div>
                    </div>
                    <div className="web-id-front-text">
                      <h4>Back</h4>
                    </div>
                  </div>
                )
              }
    

            </div>

          </div>

        }

        </>
        )}

      </div>

      {/* Submit Button */}
      <div className='form-approve'>
        <div className='form-approve-para'>
          <p>
            {isMinor
              ? "I confirm this child is travelling with an accompanying adult in this room."
              : "I declare that this ID belongs to me and the details provided are authentic"}
          </p>
        </div>
        <div className='form-approve-btn'>
          <button onClick={()=>handleSave()} disabled={buttonDisabled} >
            Save
          </button>
        </div>
      </div>


      {/* Image Modal */}
      {showImageModal && (
        <div className="image-modal">
          <div className="modal-content">
            <span className="close-btn" onClick={toggleImageModal}>
              &times;
            </span>
            {formData.filePreview ? (
              <Zoom>
              <img src={formData.filePreview} alt="Uploaded Id" style={{ maxWidth: "90%", height: "auto" }} />
              </Zoom>
            ) : (
              imageurl ? (
                <Zoom>
                <img src={imageurl} alt="Uploaded Id" style={{ maxWidth: "90%", height: "auto" }} />
                </Zoom>
              ) : (
                <ImageLoader  />
              )
            )}
          </div>
        </div>
      )}

      {imageModal1 && (
          <div className="image-modal">
              <div className="modal-content">
                  <span className="close-btn" onClick={()=>toggleImageModelId1()}>
                      &times;
                  </span>
              
                  <Zoom>
                      <img src={urlId1} alt="Uploaded Id"   />
                  </Zoom>
              </div>
          </div>
      )}

      {imageModal2 && (
          <div className="image-modal">
              <div className="modal-content">
                  <span className="close-btn" onClick={()=>toggleImageModelId2()}>
                      &times;
                  </span>
              
                  <Zoom>
                      <img src={urlId2} alt="Uploaded Id"   />
                  </Zoom>
              </div>
          </div>
      )}

    </div>
    </>
  )
}
